
const nameList = [
    {
        entityField: "groupCode",
        showField: "价格组编号",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "groupName",
        showField: "价格组名称",
        fieldWeight: 100,
        fieldType: "string",

    },

    {
        entityField: "remark",
        showField: "备注",
        fieldWeight: 130,
        fieldType: "string",

    },


]


const storeList = [
    {
        entityField: "bgmCode",
        showField: "商品编号",
        fieldWeight: 70,
        fieldType: "string",

    },
    {
        entityField: "bgmName",
        showField: "通用名字",
        fieldWeight: 70,
        fieldType: "string",

    },
    {
        entityField: "spec",
        showField: "规格",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "retailPrice",
        showField: "统一零售价",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "salesPrice",
        showField: "零售价",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "memberPrice",
        showField: "会员价",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        showField: "药品类型",
        entityField: "goodType",
        isShow: 1,
        fieldType: "select",
        searchId: null,
        formatterContent: [
            {
                key: "药品",
                value:0,
            },
            {
                key: "器械",
                value:1,
            },
        ],
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },
    {
        entityField: "bgiPretype",
        showField: "处方类型",
        fieldWeight: 100,
        fieldType: "string",

    },
    // {
    //     entityField: "groupName",
    //     showField: "价格组名称",
    //     fieldWeight: 100,
    //     fieldType: "string",

    // },
   
    {
        entityField: "bgiAppnumber",
        showField: "批准文号",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "bgiPerholder",
        showField: "上市许可持有人",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "manufacturer",
        showField: "生产商",
        fieldWeight: 100,
        fieldType: "string",

    },
 

 
        {
            entityField: "placeorigin",
            showField: "产地",
            fieldWeight: 100,
            fieldType: "string",

        },

    // {
    //     entityField: "remark",
    //     showField: "备注",
    //     fieldWeight: 130,
    //     fieldType: "string",

    // },
   
]
const  searchList= [
   

    {
        showField: "价格组名称",
        entityField: "groupName",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },

   
]
const searchList2 = [
    // {
    //     showField: "商品名称",
    //     entityField: "bgmName",
    //     isShow: 1,
    //     fieldType: "search",
    //     searchId: 293839281728,
    //     formatterContent: null,
    //     isRift: null,
    //     riftField: null,
    //     setField: "bgmName,bgmId",
    //     fieldWeight: 120,
    // },
  
    {
        showField: "商品名称",
        entityField: "bgmName",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },

]





export {nameList, storeList,searchList,searchList2}